<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div >
      <!-- class="mod-joylearning__courseinfo}" -->
                     <!-- :inline="true" -->
      <!-- <el-form label-width="auto"
                label-position="left"
               :model="dataForm"
               @keyup.enter.native="getDataList()"> -->
           <el-form label-width="180px"
               width="90%"
               label-position="top"
               :model="dataForm"
               @keyup.enter.native="getDataList()">
         <el-row class="margb10">
          <el-col :span="10">
            <el-form-item :label="$t('couse.coursecodes')">
              <el-input v-model="dataForm.courseCode"
                        clearable></el-input>
            </el-form-item>
          </el-col>
            <el-col :span="10">
           <!-- 课程类型 -->
            <el-form-item :label="$t('couse.coursekinds')"
                          prop="courseKind">
              <el-select v-model="dataForm.courseKind"
                         filterable
                         clearable
                         :placeholder="$t('course.select')">
                <!-- <el-option v-for="(item,index) in newcourseKind"
                           :key="index"
                           :label="item.name"
                           :value="item.code"> -->
                           <el-option v-for="item in newcourseKind"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="getDataList()">{{ $t('query') }}</el-button>
            </el-col>
             <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                     @click="toggleSelection(inputvalues)">确定</el-button>
            </el-col>
          </el-col>
        </el-row>
          <!-- <el-input v-model="inputvaluesz"></el-input> -->
          <!-- <el-button class="el-button-columnBtn"
                     @click="toggleSelection(inputvalues)">选中</el-button> -->
          <!-- <el-button class="el-button-columnBtn"
                     @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          <el-button class="el-button-columnBtn"
                     @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button> -->
      </el-form>
      <!-- max-height="250" -->
      <el-table v-loading="dataListLoading"
                ref="multipleTable"
                height="350"
                :data="dataList"
                border
                @selection-change="dataListSelectionChangeHandle"
                @sort-change="dataListSortChangeHandle"
                style="width: 100%;">
        <el-table-column type="selection"
                         header-align="center"
                         align="center"
                         width="50"></el-table-column>
        <el-table-column prop="courseCode"
                         :label="$t('couse.coursecode')"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="courseNameCn"
                         :label="$t('couse.courseNamecns')"
                         header-align="center"
                         align="center">
        </el-table-column>
        <el-table-column prop="courseKind"
                         :label="$t('couse.courseCoursekinds')"
                         header-align="center"
                         align="center">
        </el-table-column>

      </el-table>
      <!-- v-if="dataForm.courseBaseId === '0'" -->
      <el-row>
           <el-col :span="8">
          <el-row>
          <span style="width: 200px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </el-row>
          <el-row>
          <span style="width: 200px">注:该列表只显示已发布的课程</span>
          </el-row>
         </el-col>
         <el-col :span="14">
      <el-pagination
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
      </el-col>
      <el-col :span="2">
        <span style="width: 200px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </el-col>
      </el-row>
    </div>
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
// import { moduleRoutes } from '@/router'
export default {
  mixins: [mixinViewModule],
  props: {
    inputvalues: String
  },
  data () {
    // let _this = this
    let _this = this
    return {
      labelPosition: 'right',
      inputvaluesz: '',
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: '/learning/courseBaseInfo/page',
        // getDataListURL: '/sys/commdict/list',
        getDataListIsPage: true,
        deleteIsBatch: true
      },
      // 课程类型
      newcourseKind: _this.enums['newcourseKindf2f'],
      // 面授课
      // 慕课
      // 微课
      // 混合式学习
      // 认证
      // 考试
      // 直播
      //  面授课
      // 混合式学习
      // 慕课
      // 微课
      // 资料
      // 辅导
      // 直播
      newcourseKind1: [{
        value: '10',
        label: '面授课'
      },
      {
        value: '20',
        label: '微课'
      },
      {
        value: '30',
        label: '慕课'
      },
      {
        value: '40',
        label: '混合式学习'
      }
      ],
      datalist: [],
      dataForm: {
        courseBaseId: '',
        courseCode: ''
        // courseNameCn: '',
        // dictName: '',
        // dictType: '',
        // dictValue: ''
      }
    }
  },
  components: {
    //  AddOrUpdate
  },
  // created () { // this.$message("11111111111111");
  //   // 通过路由参数pid, 控制列表请求操作
  //   this.dataForm.courseBaseId = this.$route.params.courseBaseId
  //   console.log('pid: == ' + this.dataForm.courseBaseId)
  //   this.$message('11111111111111' + this.dataForm.courseBaseId)
  //   if (this.dataForm.courseBaseId !== '0') {
  //     this.mixinViewModuleOptions.getDataListURL = '/learning/course/courseBaseInfo/page'
  //     this.mixinViewModuleOptions.getDataListIsPage = true
  //     this.dataForm.dictType = this.$route.params.type || ''
  //   }
  //   console.log(this.dataForm)
  //   this.getDataList()
  // },
  created () {
    this.mixinViewModuleOptions.getDataListURL = '/learning/courseBaseInfo/page'
    this.mixinViewModuleOptions.getDataListIsPage = true
    this.getDataList()
  },

  // activated () {
  //   // 通过路由参数pid, 控制列表请求操作
  //   // this.$message('11111111111111' + this.dataForm.courseBaseId)
  //   // this.dataForm.courseBaseId = this.$route.params.courseBaseId || '0'
  //   // if (this.dataForm.courseBaseId !== '0') {
  //   this.mixinViewModuleOptions.getDataListURL = '/learning/courseBaseInfo/page'
  //   this.mixinViewModuleOptions.getDataListIsPage = true
  //   // this.dataForm.dictType = this.$route.params.type || ''
  //   // }
  //   this.getDataList()
  // },
  methods: {
    toggleSelection (rows) {
      var chexcksss = this.$refs.multipleTable.selection// 得到选中的值
      chexcksss.forEach(row => {
        this.datalist.push({ id: row.courseId, courseKind: row.courseKind, course: row.courseCode + '-' + row.courseNameCn })
      })
      // this.$message('' + this.datalist)

      this.$emit('inputss', this.datalist)
      this.datalist = []
    }

  }
}
</script>
<style lang='scss' scoped>
/*.el-step__icon.is-text {*/
/*      border-radius: 50%;*/
/*      border: 15px solid;*/
/*      border-color: inherit;*/
/*  }*/
/* .el-form--label-top .el-form-item__label {
    display: inline-block;
    text-align: left;
    padding: 0 0 10px;
} */
.el-row {
    margin-bottom: 1px;
}
.el-form-item__label {
    display: inline-block;
    text-align: left;
    padding: 0 0 10px;
}
</style>
